import { render, staticRenderFns } from "./TitleWithSubclass.vue?vue&type=template&id=d423c384"
import script from "./TitleWithSubclass.vue?vue&type=script&lang=js"
export * from "./TitleWithSubclass.vue?vue&type=script&lang=js"
import style0 from "./TitleWithSubclass.vue?vue&type=style&index=0&id=d423c384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports